import { EndPoint } from '../../../apiConfigs';
import { TrailQueryApi, TrailsResponse } from '../../../apiConfigs/@types';

export const fetchTrails = async () => {
  const resp = await fetch(EndPoint.Trail.ALL);
  const trails = (await resp.json()) as TrailsResponse;
  return trails;
};

export const fetchQueryTrails = async (
  query: TrailQueryApi['Request'],
  reportStartDate: string,
  reportEndDate: string,
  occurence: string[],
) => {
  const searchParams = new URLSearchParams(query).toString();
  const resp = await fetch(EndPoint.Trail.ALL + '?' + searchParams);
  const trails = (await resp.json()) as TrailsResponse;

  // WTF is this?
  // filter by occurence
  occurence.length &&
    (trails.features = trails.features.filter((feature) =>
      // occurence.includes(feature.properties?.occurrence)
      occurence.some((occ) => feature.properties?.occurrence?.includes(occ)),
    ));
  // filter by report date
  reportStartDate &&
    reportEndDate &&
    (trails.features = trails.features.filter(
      (feature) =>
        feature.properties?.report_date >= reportStartDate &&
        feature.properties?.report_date <= reportEndDate,
    ));

  return trails;
};
